const getPersonCount = (guest) => {
    if (guest.isFamilyGroup) {
        const members = guest.familyMembers || [];
        return {
            attending: members.filter(m => m.attending === true).length,
            notAttending: members.filter(m => m.attending === false).length,
            pending: members.filter(m => m.attending === null || m.attending === undefined).length,
            total: members.length,
        };
    }
    // Obični gost
    if (guest.rsvpDate && guest.isAttending) {
        const extra = 1 + (guest.companions?.unregistered || 0);
        return { attending: extra, notAttending: 0, pending: 0, total: extra };
    }
    if (guest.rsvpDate && !guest.isAttending) {
        return { attending: 0, notAttending: 1, pending: 0, total: 1 };
    }
    return { attending: 0, notAttending: 0, pending: 1, total: 1 };
};

const StatsBar = ({ guests }) => {
    let attending = 0;
    let notAttending = 0;
    let pending = 0;
    let totalSeats = 0;
    let withTable = 0;

    guests.forEach(g => {
        const c = getPersonCount(g);
        attending += c.attending;
        notAttending += c.notAttending;
        pending += c.pending;

        if (g.reservedTableId) withTable += 1;

        if (g.isFamilyGroup) {
            totalSeats += c.attending;
        } else if (g.isAttending) {
            totalSeats += 1 + (g.companions?.unregistered || 0);
        }
    });

    const stats = [
        { label: 'Dolaze', value: attending, color: 'text-green-600' },
        { label: 'Ne dolaze', value: notAttending, color: 'text-red-500' },
        { label: 'Čeka', value: pending, color: 'text-gray-500' },
        { label: 'Ima stol', value: withTable, color: 'text-blue-600' },
        { label: 'Ukupno mjesta', value: totalSeats, color: 'text-rose-500' },
    ];

    return (
        <div className="grid grid-cols-5 gap-2 bg-white border border-gray-200 rounded-2xl p-3 mb-4">
            {stats.map(s => (
                <div key={s.label} className="flex flex-col items-center">
                    <span className={`text-lg font-bold ${s.color}`}>{s.value}</span>
                    <span className="text-xs text-gray-400 text-center leading-tight">{s.label}</span>
                </div>
            ))}
        </div>
    );
};

export default StatsBar;
